export default function scrollIntoViewIfNecessary(
    targetEl?: Element | null,
    opts: ScrollIntoViewOptions = { behavior: "auto", block: "center" }
) {
    if (!targetEl) {
        return null;
    }

    const observer = new IntersectionObserver(
        (entries, observerInstance) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                    targetEl!.scrollIntoView(opts);
                }

                // Disconnect the observer after the check
                observerInstance.disconnect();
            });
        },
        {
            root: null, // Use the viewport as the container.
            threshold: 0.1 // Trigger if at least 10% of the element is not visible.
        }
    );

    observer.observe(targetEl);
}
